import type Modal from 'src/components/common/modal.svelte';

export function handleToggleModal(firstModal: Modal, secondModal: Modal) {
	firstModal.close();
	secondModal.open();
}
